<div class="result-vneid-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <button type="button" class="close-btn" aria-label="Close" (click)="onNoClick(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Body -->
  <div mat-dialog-content class="dialog-body">
    <div class="icon-wrapper">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="type === 'SUCCESS'">
        <rect width="48" height="48" rx="24" fill="#ECFDF3"/>
        <path d="M34 23.0857V24.0057C33.9988 26.1621 33.3005 28.2604 32.0093 29.9875C30.7182 31.7147 28.9033 32.9782 26.8354 33.5896C24.7674 34.201 22.5573 34.1276 20.5345 33.3803C18.5117 32.633 16.7847 31.2518 15.611 29.4428C14.4373 27.6338 13.8798 25.4938 14.0217 23.342C14.1636 21.1903 14.9972 19.1421 16.3983 17.5028C17.7994 15.8635 19.6928 14.7211 21.7962 14.2459C23.8996 13.7706 26.1003 13.9881 28.07 14.8657M34 16L24 26.01L21 23.01" stroke="#12B76A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="type === 'ERROR'">
        <rect width="48" height="48" rx="24" fill="#FDE6EB"/>
        <path d="M23.9998 21.0002V25.0002M23.9998 29.0002H24.0098M22.6151 15.892L14.3902 30.0986C13.934 30.8866 13.7059 31.2806 13.7396 31.6039C13.769 31.886 13.9168 32.1423 14.1461 32.309C14.4091 32.5002 14.8643 32.5002 15.7749 32.5002H32.2246C33.1352 32.5002 33.5904 32.5002 33.8534 32.309C34.0827 32.1423 34.2305 31.886 34.2599 31.6039C34.2936 31.2806 34.0655 30.8866 33.6093 30.0986L25.3844 15.892C24.9299 15.1068 24.7026 14.7142 24.4061 14.5824C24.1474 14.4673 23.8521 14.4673 23.5935 14.5824C23.2969 14.7142 23.0696 15.1068 22.6151 15.892Z" stroke="#D9002E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <p class="dialog-title">
      {{title}}
    </p>
    <p class="dialog-message">
      {{message}}
    </p>
  </div>

  <!-- Footer -->
  <div mat-dialog-actions class="dialog-actions">
    <button type="button" class="btn btn-outline" (click)="onNoClick(false)" *ngIf="type === 'ERROR'">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#EE0033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{'kyc.close' | translate}}</span>
    </button>

    <button type="button" class="btn btn-filled" [mat-dialog-close]="true" (click)="onNoClick()" *ngIf="type === 'SUCCESS'">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{'kyc.close' | translate}}</span>
    </button>
  </div>

</div>